import PropTypes from 'prop-types';
import React from 'react';

export const AtrTrailWrapper = ({ softOrder, Component, ...rest }) => {
  const details = {
    tacticName: 'ATR_TRAIL',
    category: 'Exit',
    type: 'ATR Trail',
    domain: 'Underlying',
  };
  const priceToBreak = softOrder.priceToBreak;
  const pctOfAtr = softOrder.pctOfAtr;
  const candleDuration = softOrder.atr?.candleDuration;
  const timeUnit = softOrder.atr?.timeUnit;
  return (
    <Component
      details={details}
      priceToBreak={priceToBreak}
      pctOfAtr={pctOfAtr}
      candleDuration={candleDuration}
      timeUnit={timeUnit}
      {...rest}
    />
  );
};

AtrTrailWrapper.propTypes = {
  Component: PropTypes.any,
  softOrder: PropTypes.shape({
    atr: PropTypes.shape({
      candleDuration: PropTypes.any,
      timeUnit: PropTypes.any
    }),
    pctOfAtr: PropTypes.any,
    priceToBreak: PropTypes.any
  })
};

